import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { CloseIcon, NewDownloadIcon } from "../../../assets/images";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import "./Files.scss";
import PdfPreview from "./PdfPreview";

type AppProps = {
  resetImageUrl: () => void;
  imageDetails: ImageDataType | undefined;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const ImagePreview = ({ imageDetails, resetImageUrl }: AppProps) => {
  const handleDownload = async () => {
      const response = await fetch(
        `${blobBaseUrl}${imageDetails?.downloadImage}?${blobToken}`
      );
      const blob = await response.blob(); 
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = url;
      a.download = imageDetails?.finalFileName || "downloaded_file";
      document.body.appendChild(a);
      a.click();
      a.remove(); 
  
      window.URL.revokeObjectURL(url); 
  };
  return (
    <Modal isOpen={!!imageDetails?.imageUrl?.length} size="lg">
      <div
        className="pt-4,pl-4"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: `20px 20px ${
            imageDetails?.fileType === "application/pdf" ? "5px" : "20px"
          } 20px`,
        }}
      >
        <div>
          <h4 className="header">
            {imageDetails?.finalFileName &&
            imageDetails?.finalFileName?.length > 40
              ? imageDetails?.finalFileName.slice(0, 40) + "..."
              : imageDetails?.finalFileName}
          </h4>
          <h6 className="bottom-header">
            {imageDetails?.updateBy ? imageDetails?.updateBy : ""}{" "}
            {imageDetails?.updatedAt ? imageDetails?.updatedAt : ""}
          </h6>
        </div>

        <div style={{ display: "flex", gap: "25px", alignItems: "center" }}>
          {blobBaseUrl && imageDetails?.downloadImage && (
              <button className="btn btn-primary" onClick={handleDownload}>
                <span className="pr-2">
                  <img src={NewDownloadIcon} alt="download" />
                </span>
                Download
              </button>
          )}
          <span
            onClick={resetImageUrl}
            style={{ cursor: "pointer", border: "none" }}
          >
            <img src={CloseIcon} alt="download"/>
          </span>
        </div>
      </div>

      <ModalBody style={{ padding: 0, minHeight: "70vh" }}>
        {imageDetails?.fileType === "application/msword" ||
        imageDetails?.fileType === "application/vnd.ms-excel" ||
        imageDetails?.fileType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        imageDetails?.fileType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        imageDetails?.fileType ===
          "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
        imageDetails?.fileType === "application/vnd.ms-powerpoint" ? (
          blobBaseUrl &&
          imageDetails?.downloadImage && (
              // eslint-disable-next-line
            <iframe
              src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                blobBaseUrl + imageDetails?.downloadImage + "?" + blobToken
              )}`}
              width="100%"
              height="400px"
            />
          )
        ) : imageDetails?.fileType === "application/pdf" ? (
          <PdfPreview imageDetails={imageDetails} />
        ) : (
          <img
            width="100%"
            height="450px"
            src={imageDetails?.imageUrl}
            alt={`file_manager_${imageDetails?.finalFileName}`}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ImagePreview;



